import React from "react";
import point from "./../../../../../Images/point.png";

function TrendyHairHighlightEspresso() {
  return (
    <div className="blogWhat-content">
      <h5>10. Espresso & Caramel Highlights for Dimension ☕</h5>
      <p>
        Dark-haired beauties, this one’s for you! Espresso hair with caramel
        highlights creates a deep, dimensional look that adds warmth and
        contrast, making it one of the best hair highlights for women in 2025.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Enhances dark hair with richness{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Perfect for a natural yet enhanced
            look
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Low-maintenance and timeless
          </span>
        </li>
      </ul>
    </div>
  );
}

export default TrendyHairHighlightEspresso;
